export default "__VITE_ASSET__ENJra6kG__"